export const formatPhone = (phone: string, onlyDigits = true) => {
  if (!phone) {
    return phone;
  }
  const p = onlyDigits ? phone.replace(/\D/g, '') : phone.slice(0, 10);
  return [
    '+',
    p[0] || '',
    ' ',
    '(',
    p[1] || '',
    p[2] || '',
    p[3] || '',
    ')',
    ' ',
    p[4] || '',
    p[5] || '',
    p[6] || '',
    '-',
    p[7] || '',
    p[8] || '',
    '-',
    p[9] || '',
    p[10] || '',
  ].join('');
};
